import React from "react"
import ModalButtons from "../ModalButtons/ModalButtons"
import Tabs from '../Tabs/Tabs';
import SeasonPresenterTabContent from "./SeasonPresenterTabContent"
import DateHelper from '../DateHelper/DateHelper'


class SeasonPresenter extends React.Component {

  constructor(props) {
    super(props)

    // init all seasonal prices
    var all_seasonal_prices = [];
    for (var i = 0, ilen = this.props.all_room_types.length; i < ilen; i++) {
      var matchingSeasonalPrice = false;

      for (var j = 0, jlen = this.props.seasonal_prices.length; j < jlen; j++) {
        if (this.props.all_room_types[i].id == this.props.seasonal_prices[j].room_type_id) {
          matchingSeasonalPrice = this.props.seasonal_prices[j];
          break;
        }
      }

      if (matchingSeasonalPrice) {
        all_seasonal_prices.push(matchingSeasonalPrice);
      } 
    }

    this.state = {
      activeTab: 'general',
      loading: false,
      all_seasonal_prices: all_seasonal_prices,
      all_room_types: this.props.all_room_types,
      all_rates: this.props.all_rates,
      country: this.props.country,
      exact_end_date: this.props.exact_end_date || null,
      exact_start_date: this.props.exact_start_date || null,
      holiday: this.props.holiday,
      holiday_days_after: this.props.holiday_days_after,
      holiday_days_before: this.props.holiday_days_before,
      holiday_name: this.props.holiday_name,
      holiday_region: this.props.holiday_region,
      holiday_year: this.props.holiday_year,
      id: this.props.id,
      name: this.props.name,
      code: this.props.code,
      repeats: this.props.repeats ? this.props.repeats : 'no',
      season_type: this.props.season_type,
      seasonal_rates: this.props.seasonal_rates || [],
      status: this.props.status,
      updated_at: this.props.updated_at,
      rates: this.props.rates
    }

    this.onSetActiveTab = this.onSetActiveTab.bind(this)
  }

  componentDidMount() {
    var self = this
    $(window).on("seasonSaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/seasons/${self.props.id}/data`,
      }).done((data) => {
        self.setState({...data});
      })
    });
  }

  render() {
    var self = this

    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: ['data-dismiss="modal"']
      }
    ]

    return (
      <div className="season-builder">
        <div className="season">
          <Tabs tabs={this.tabs()} />
          <div className="panel panel-form">
            <ModalButtons loading={this.state.loading} buttons={buttons} />
            <SeasonPresenterTabContent
              {...this.state}
              season_id={this.props.id}
              date_format={this.props.date_format}
              disabled={this.props.disabled}
              time_format={this.props.time_format}
              season_revision_history_path={this.props.season_revision_history_path}
              />
          </div>
          <div className="overlay">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  };

  tabs(){
    if (this.props.historical_view == true) {
      return(
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.activeTab === 'general' ? 'active' : null,
            changeHandler: this.onSetActiveTab,
          },
        ]
      )
    } else {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.activeTab === 'general' ? 'active' : null,
            changeHandler: this.onSetActiveTab,
          },
          {
            tabName: I18n.t('room_types'),
            targetName: 'room_types',
            classes: this.state.activeTab === 'room_types' ? 'active' : null,
            changeHandler: this.onSetActiveTab,
          },
          {
            tabName: I18n.t('rates'),
            targetName: 'rates',
            classes: this.state.activeTab === 'rates' ? 'active' : null,
            changeHandler: this.onSetActiveTab,
          },
          {
            tabName: I18n.t('history'),
            targetName: 'history',
            classes: this.state.activeTab === 'history' ? 'active' : null,
            changeHandler: this.onSetActiveTab,
          },
        ]
      );
    };
  };

  onSetActiveTab(name) {
    this.setState({activeTab: name})
  };

};

export default SeasonPresenter
